// extracted by mini-css-extract-plugin
export default {"Content":"LoadingEnvironmentScreen_Content__O6ayr","Logo":"LoadingEnvironmentScreen_Logo__1xUKH","Label":"LoadingEnvironmentScreen_Label__8jfZT"};